import React from "react";
import {
  Menu,
  Home,
  Ballot,
  LocalLaundryService,
  Category,
  ArrowRight,
  Forum,
  ExitToApp,
} from "@material-ui/icons";
import "../App.css";
import { NavLink } from "react-router-dom";

import logo from "../assets/images/One.all.jpg";

function Navbar() {
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-10 mx-auto">
            <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top" id="mainNav">
              <div className="container">
                <NavLink className="navbar-brand" to="/" exact>
                  One.all
                </NavLink>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarNavDropdown"
                  aria-controls="navbarNavDropdown"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <Menu />
                </button>
                <div className="collapse navbar-collapse" id="navbarNavDropdown">
                  <ul className="navbar-nav ml-auto mb-2 mb-lg-0">
                    <li className="nav-item">
                      <NavLink
                        className="nav-link"
                        aria-current="page"
                        to="/"
                        exact
                      >
                        <Home /> Home
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav-link"
                        aria-current="page"
                        to="/about"
                        exact
                      >
                        <Ballot /> About
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav-link"
                        aria-current="page"
                        to="/plans"
                        exact
                      >
                        <LocalLaundryService /> Plans
                      </NavLink>
                    </li>
                    <li className="nav-item dropdown">
                      <a
                        className="btn nav-link dropdown-toggle text-center"
                        id="navbarDropdownMenuLink"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        href="www.onedotall.in"
                      >
                        <Category /> Ventures
                      </a>
                      <ul
                        className="dropdown-menu"
                        aria-labelledby="navbarDropdownMenuLink"
                      >
                        <li>
                          <a className="dropdown-item bg-white text-dark" href="https://www.youtube.com/channel/UCZLta3G00zz9Jc4zsiCRhtA" target="_blank" rel="noopener noreferrer">
                            <ArrowRight /> Youtube
                          </a>
                        </li>
                        <li>
                          <NavLink className="dropdown-item bg-white text-dark" to="/reiki">
                            <ArrowRight /> Reiki
                          </NavLink>
                        </li>
                        {/* <li>
                          <NavLink className="dropdown-item bg-white text-dark" to="/p404">
                            <ArrowRight /> Weblates
                          </NavLink>
                        </li> */}
                      </ul>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        className="nav-link"
                        aria-current="page"
                        to="/contact"
                        exact
                      >
                        <Forum /> Contact
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <button className="btn btn-outline-warning" data-toggle="modal" data-target="#staticBackdrop">
                        <ExitToApp /> Login
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
      <div className="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="staticBackdropLabel">Admin Login</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form className="form-signin">
                <img className="mb-4" src={logo} alt="Logo" width="72" height="72" />
                <label htmlFor="inputUser" className="sr-only">Email</label>
                <input type="email" id="inputUser" className="form-control" placeholder="Email" required autoFocus />
                <br />
                <label htmlFor="inputPassword" className="sr-only">Password</label>
                <input type="password" id="inputPassword" className="form-control" placeholder="Password" required />
                <br />
                <button className="btn btn-lg btn-success btn-block" type="submit">Login</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;
